<template>
  <div
    id="content"
    class="flex-column"
  >
    <div class="flex-column">
      <p class="title">
        Crie uma senha
      </p>
      <p class="text">
        Crie agora a senha da sua conta Pravaler. Com ela você terá acesso ao app e ao portal de financiamento. Caso
        precise, poderá continuar o preenchimento dos seus dados de onde parou.
      </p>
    </div>
    <form
      id="rb-form"
      class="flex-column"
      @submit.prevent="submit"
    >
      <RbInput
        id="password"
        v-model="password"
        label="Nova senha"
        type="password"
        :min-length="8"
        required
        primary
        @change="validatePassword"
      />
      <RbInput
        id="confirmation"
        v-model="confirmationPassword"
        label="Confirmar senha"
        type="password"
        required
        primary
        @change="validatePassword"
      />
    </form>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import RbInput from '../standards/RbInput.vue';
import { loaderStore, stepStore, proposalStore, snackbarStore } from '@/store/app';

const password = ref('');
const confirmationPassword = ref('');

function validatePassword() {
  const confirmation = document.querySelector('#confirmation input') as any;
  confirmation.setCustomValidity(!confirmationIsValid() ? 'As senhas não são iguais' : '');
}

function confirmationIsValid() {
  return confirmationPassword.value && password.value === confirmationPassword.value;
}

async function submit() {
  if (confirmationIsValid()) {
    try {
      loaderStore().setOpen(true);
      await proposalStore().send({ password: confirmationPassword.value });
      await proposalStore().submit();
      stepStore().nextStep('feedback');
    } catch (error) {
      snackbarStore().alert('Tivemos um problema, tente novamente mais tarde!');
    }
    finally {
      loaderStore().setOpen(false);
    }
  }
}
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}

#content {
  margin: 1.3rem 1.15rem;
  display: flex;
  flex-direction: column;
  gap: 16px;

  .title {
    font-family: Poppins;
    font-size: 1rem;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: left;
  }

  .text {
    font-size: 0.90rem;
    font-weight: 400;
    line-height: 1.45rem;
    letter-spacing: 0.025em;
    text-align: left;
    color: rgba(77, 77, 77, 1);
  }

  &>div {
    gap: 16px;
  }

  &>form {
    gap: 25px;

    &>span {
      text-align: center;
      font-size: 0.75rem;
      color: rgba(77, 77, 77, 1);
      width: 100%;
      background-color: color-mix(in srgb, var(--primary) 25%, transparent);
      border-radius: 4px;
      padding: 2px;
    }
  }
}
</style>
